import { render, staticRenderFns } from "./FiltersProcesos.vue?vue&type=template&id=140587d8"
import script from "./FiltersProcesos.vue?vue&type=script&lang=js"
export * from "./FiltersProcesos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports